import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';

export function ClearFilters({ onClick }) {
  return (
    <Button className="responsive-filters-toggle me-2" variant="ghost" onClick={onClick}>
      Clear All
    </Button>
  );
}

ClearFilters.propTypes = {
  onClick: PropTypes.func
};

export default ClearFilters;
